// extracted by mini-css-extract-plugin
export default {"Container":"ConfirmationForgotPasswordMail_Container__soZli","Content":"ConfirmationForgotPasswordMail_Content__8qaRV"};